import localforage from 'localforage';

const isObject = (obj) => obj && typeof obj === 'object';
const isKeyToMerge = (exceptionsKeys, key, obj) => {
    const includesKey = exceptionsKeys.includes(key);
    return !includesKey || ((obj && !isEmpty(obj)));
};

const isEmpty = (obj) => {
    return (Array.isArray(obj) && obj.length === 0) || (obj.constructor === Object && Object.keys(obj).length === 0);
};

export const mergeInnerProperties = (exceptionsKeys, ...objects) => {
    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach((key) => {
            const prevElement = prev[key];
            const objElement = obj[key];
            const elementsNotArray = !Array.isArray(prevElement) && !Array.isArray(objElement);
            const elementsAreObject = isObject(prevElement) && isObject(objElement);
            if (elementsNotArray && elementsAreObject && isKeyToMerge(exceptionsKeys, key, objElement)) {
                prev[key] = mergeInnerProperties(exceptionsKeys, prevElement, objElement);
            } else {
                if (isKeyToMerge(exceptionsKeys, key, objElement, prevElement)) {
                    prev[key] = objElement;
                }
            }
        });
        return prev;
    }, {});
};

export const getInitialStore = (bookingId) => localforage.getItem(`store${bookingId}`);
